import { atom } from 'recoil';
const defaultValue = {};

export const mainStore = atom({
  key: 'mainStore',
  default: defaultValue as CurrentUser,
});

export const permissionStore = atom({
  key: 'permissionStore',
  default: [] as string[],
});

export const exportModalVisibleStore = atom({
  key: 'exportModalStore',
  default: false,
});
